import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import Map from "./Map";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  field: IField;
}

const MapLocation: React.FC<Props> = ({ form, field }) => {
  const fConfig = field.configurations;
  return (
    <Controller
      name={fConfig.key}
      control={form.control}
      rules={{}}
      render={({ field }) => (
        <Map
          position={field.value}
          onChange={(location) => field.onChange(location)}
        />
      )}
    />
  );
};
export default MapLocation;
